import React, { useEffect, useRef, useState } from 'react';
import './admin-content-landing.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { getOrgsFromDb } from '@/utils/getAdminData';
import { getGameDataFromDb, getMyContentFromDb, getPackageFromDb } from '@/utils/getDataFromDb';
import { set } from 'date-fns';
import { get } from 'firebase/database';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import AdminTemplateGames from './template-games.component';
import AdminAddElementModal from './add-element-modal.component';
import { ModalAlert } from '@/components/modal/modal.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import ManageContent from './manage-content.component';

const AdminContentLanding = ({
    owners
}) => {

    const [ orgList, setOrgList ] = useState(null);
    const [ selectedOwner, setSelectedOwner ] = useState(null);
    const [ selectedOrganization, setSelectedOrganization ] = useState(null);
    const [ selectedPackage, setSelectedPackage ] = useState(null);
    const [ packageList, setPackageList ] = useState(null);
    const [ contentToDisplay, setContentToDisplay ] = useState(null);
    const [ contentType, setContentType ] = useState(null);
    const [ info, setInfo ] = useState(null);
    const [ elementTypes, setElementTypes ] = useState(null);
    const [ selectedElementType, setSelectedElementType ] = useState(null);
    const [ contentContainer, setContentContainer ] = useState(null);
    const [ showAddElementModal, setShowAddElementModal ] = useState(false);
    const [ templateGames, setTemplateGames ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState('');
    const navigate = useNavigate();
    const orgListRef = useRef();
    const approveRef = useRef();
    let orgListener;

    useEffect(() => {
        getOrgs();
        getPackages();
        getTemplateGames();
        changeDocumentTitle('Gamably Admin | Manage Content');
        
        return () => {
            if (orgListener) orgListener();
        }
    }, [])

    async function getOrgs() {
        getOrgsFromDb({
            'callback': callback,
            'handleListener': handleListener
        })
        function callback(data) {
            orgListRef.current = {
                ...orgListRef.current, 
                ...{[data.orgId]: data}
            }
            setOrgList(orgListRef.current);
        }
        function handleListener(unsub) {
            orgListener = unsub;    
        }
    } 

    async function getPackages() {
        getPackageFromDb({
            'callback': callback,
        });
        function callback(data) {
            setPackageList(data);
        }
    }

    function getTemplateGames() {
        getGameDataFromDb({
            'template': true,
            'once': true,
            'callback': callback,
        })
        function callback(data) {
            console.log(data);
            setTemplateGames(data);
        }
    }

    function chooseContent(e) {
        const methodObj = {
            'owner': () => {
                setSelectedOwner(e.value);
                setSelectedOrganization(null);
                setSelectedPackage(null);
            },
            'org': () => {
                setSelectedOwner(null);
                setSelectedOrganization(e.value);
                setSelectedPackage(null);
            },
            'pkg': () => {
                setSelectedOwner(null);
                setSelectedOrganization(null);
                setSelectedPackage(e.value);
            }
        }
        const method = e.type;
        methodObj[method]();
        setContentType(e.type);
        setContentContainer(e.value);
        if (e.type === 'pkg') {
            getPackageFromDb({
                'packageId': e.value,
                'callback': callback,
            })
        } else {
            getMyContentFromDb({
                'appId': e.value,
                'callback': callback,
                'once': true
            })
        }
        function callback(data) {
            console.log(data);
            if (data && data['00_info']) {
                setInfo(data['00_info']);
                delete data['00_info'];
            } else if (e.type === 'org') {
                setInfo({
                    'name': orgList[e.value].name,
                    'id': e.value,
                    'icon': orgList[e.value].icon,
                    'type': 'org'
                });
            } else if (e.type === 'owner') {
                setInfo({
                    'fName': owners[e.value].fName,
                    'lName': owners[e.value].lName,
                    'name': owners[e.value].lName + ', ' + owners[e.value].fName,
                    'id': e.value,
                    'icon': owners[e.value].icon,
                    'type': 'owner'
                });
            }
            setContentToDisplay(data);
            const types = [...new Set(Object.values(data).map(item => item.type))];
            setElementTypes(types);
        }
    }

    function addElement() {
        setShowAddElementModal(true);
    }

    return (
        <div className='admin-content-landing'>
            <Routes>
                <Route path='' element={
                    <div className='admin-content-landing__content'>
                        <div className='section-title with-icon'>
                            <span>Manage Content</span>
                        </div>
                        <hr />
                        <ManageContent
                          owners={owners} />
                    </div>
                }></Route>
                <Route path='templategames' element={
                    <AdminTemplateGames
                        templateGames={templateGames}
                        owners={owners}
                        packageList={packageList} />
                }></Route>
            </Routes>
            <AdminAddElementModal
                show={showAddElementModal}
                cancel={() => setShowAddElementModal(false)}
                contentType={contentType}
                contentContainer={contentContainer}
                alertMessage={alertMessage}
                setAlertMessage={setAlertMessage} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default AdminContentLanding